import * as Sentry from "@sentry/nextjs";
import translate from "@deosite/helpers/langLibrary";
import PageContainer from "../containers/UI/PageContainer";
import Container from "@commerce-ui/core2/Container";
import Box from "@commerce-ui/core2/Box";
import LinkRaw from "@commerce-ui/core2/LinkRaw";
import { useRouteContext } from "@deosite/lib/RouteContext";
import { useRecentlyViewedProducts } from "@deosite/api/hooks/common/useRecentlyViewedProducts";
import ProductBox from "../components/ProductBox";
import Grid from "@commerce-ui/core2/Grid";

const ErrorPage = props => {
  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title"),
    possibleFailure: translate(
      "Possible service failure. Please wait a moment and try again."
    ),
    pageNotFound: translate("Page not found"),
    goToHomePage: translate("Go to home page"),
    recentlyViewed: translate("Check recently viewed")
  };

  const { Link } = useRouteContext();

  const recentlyViewedProducts = useRecentlyViewedProducts();

  return (
    <PageContainer
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      recentlyViewedActive={false}
      footerContent={props.footerContent}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            mt: "s10",
            color: "main",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            minHeight: "50vh"
          }}
        >
          <Box as={"p"} sx={{ font: "xxl" }}>
            {props.statusCode
              ? props.statusCode === 404
                ? translations.pageNotFound
                : translations.possibleFailure
              : translations.possibleFailure}
          </Box>
          {recentlyViewedProducts?.length > 0 && props.statusCode === 404 ? (
            <Box sx={{ mt: "s8" }}>
              <Box
                as={"p"}
                sx={{
                  color: "main",
                  font: "base",
                  my: "s8",
                  textAlign: "center"
                }}
              >
                {translations.recentlyViewed}
              </Box>
              <Grid
                cols={[
                  recentlyViewedProducts?.length / 2,
                  null,
                  recentlyViewedProducts?.length,
                  null
                ]}
                sx={{ gridRowGap: "s11" }}
              >
                {recentlyViewedProducts.map((product, index) => (
                  <ProductBox key={index} product={product} />
                ))}
              </Grid>
            </Box>
          ) : (
            <Link route={"home-page"}>
              <LinkRaw
                title={translations.goToHomePage}
                sx={{ color: "active", font: "base", mt: "s8" }}
              >
                {translations.goToHomePage}
              </LinkRaw>
            </Link>
          )}
        </Box>
      </Container>
    </PageContainer>
  );
};

ErrorPage.getInitialProps = async contextData => {
  await Sentry.captureUnderscoreErrorException(contextData);
  const { res, err } = contextData;
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default ErrorPage;
